(function () {
  function getToggleLabels() {
    var el = document.getElementById('CollectionFacetsToggleLabels');
    if (el) {
      try {
        return JSON.parse(el.textContent.trim());
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function init() {
    var layout = document.getElementById('CollectionFacetsLayout');
    var btn = document.getElementById('CollectionFacetsToggle');
    if (!layout || !btn) return;

    var textEl = btn.querySelector('.collection-facets-toggle__text');
    var jsonLabels = getToggleLabels();
    var showL = (jsonLabels && jsonLabels.show) || btn.getAttribute('data-label-show') || '';
    var hideL = (jsonLabels && jsonLabels.hide) || btn.getAttribute('data-label-hide') || '';
    if (showL) {
      showL = String(showL).replace(/&amp;/g, '&');
    }
    if (hideL) {
      hideL = String(hideL).replace(/&amp;/g, '&');
    }

    btn.addEventListener('click', function () {
      layout.classList.toggle('collection-layout--sidebar-collapsed');
      var open = !layout.classList.contains('collection-layout--sidebar-collapsed');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (textEl) {
        textEl.textContent = open ? hideL : showL;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
